import http from "../../http-common"

class ArticlesPinnedServices {
    getAllArticlesPinned() {
        return http.get('/articles/pinned')
    }
}


export default new ArticlesPinnedServices();